<script>
import demo from './Template/index'

export default {
  ...demo,
  data () {
    const demoData = demo.data()
    return {
      ...demoData,
      tab: 'Happy81012'
    }
  }
}
</script>
